import { z } from "zod";
import useTranslation from "../common/useTranslation";

const useDashboardValidationHook = () => {
  const { t } = useTranslation();
  const getClientNameSchema = () =>
    z.string().min(1, t("error.clientName.empty"));

  return {
    getClientNameSchema,
  };
};

export default useDashboardValidationHook;
